import { useFiltersAdvancedSearchUrlFactory } from '../../../../jira/jira-advanced-search-url-factory';
export var JiraAdvancedSearchProvider = function JiraAdvancedSearchProvider(_ref) {
  var children = _ref.children;
  var generateAdvancedSearchUrl = useFiltersAdvancedSearchUrlFactory();
  return children(generateAdvancedSearchUrl);
};